<template>
  <div v-if="!isFooterOnly">
    <form @submit.prevent="handleSubmit">
      <div class="field">
        <label class="label">Invoice ID</label>
        <div class="control">
          <input type="text" class="input" :value="form.invoice_id" disabled />
        </div>
      </div>

      <div class="field">
        <label class="label">Amount *</label>
        <div class="control">
          <input
            type="number"
            step="0.01"
            class="input"
            v-model.number="form.amount"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Description *</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="form.description"
            required
          ></textarea>
        </div>
      </div>

      <div class="field">
        <p class="help">* Required fields</p>
      </div>
    </form>
  </div>

  <div v-else class="buttons">
    <button class="button" @click="closeModal">Cancel</button>
    <button class="button is-primary" @click="triggerSubmit">
      Create Payment
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { httpInstance as http } from "@/plugins/http";
import toast from "@/utils/toast";

export default {
  name: "ModalPayment",
  props: {
    modalData: {
      type: Object,
      default: () => ({}),
    },
    modalIndex: {
      type: Number,
      required: true,
    },
    isFooterOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        invoice_id: null,
        amount: null,
        description: "",
      },
    };
  },
  methods: {
    ...mapActions(["closeTopModal"]),
    closeModal() {
      this.closeTopModal();
    },
    triggerSubmit() {
      // Footer instance triggers submit on body instance
      this.$root.$emit("payment-modal-submit");
    },
    async handleSubmit() {
      try {
        // Trim description before validation
        const trimmedDescription = this.form.description.trim();

        if (!this.form.amount || !trimmedDescription) {
          toast.error("Please fill all required fields");
          return;
        }

        const formData = new FormData();
        formData.append("invoice_id", this.form.invoice_id);
        formData.append("amount", this.form.amount);
        formData.append("description", trimmedDescription);

        const response = await http.post("payments", formData);

        if (response.status === 200 || response.status === 201) {
          toast.success("Payment created successfully");
          this.closeModal();
          // Emit event to parent to refresh invoices
          this.$root.$emit("payment-created");
        }
      } catch (error) {
        console.error("Error creating payment:", error);
        toast.error("Error creating payment");
      }
    },
    initializeForm() {
      if (this.modalData) {
        this.form.invoice_id = this.modalData.invoice_id || null;
        this.form.amount = this.modalData.amount || null;
        this.form.description = this.modalData.description || "";
      }
    },
  },
  watch: {
    modalData: {
      handler() {
        this.initializeForm();
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeForm();

    // Listen for submit event from footer instance (only body instance should handle this)
    if (!this.isFooterOnly) {
      this.$root.$on("payment-modal-submit", this.handleSubmit);
    }
  },
  beforeDestroy() {
    // Clean up event listener
    if (!this.isFooterOnly) {
      this.$root.$off("payment-modal-submit", this.handleSubmit);
    }
  },
};
</script>

<style scoped>
.buttons {
  justify-content: flex-end;
}
</style>
